import React, { createContext, useEffect } from "react";

import {
  PageConfigurationQuery,
  usePageConfigurationQuery,
} from "@common-vendors/generated/graphql";

export const pageConfigInitialState = {};

type ContextData = {
  data: NonNullable<PageConfigurationQuery["cmsConfiguration"]["page"]>;
  loading: boolean;
};

export const PageConfigurationContext = createContext<ContextData>({
  data: pageConfigInitialState,
  loading: false,
});

export const PageConfigurationContextProvider: React.FC = ({ children }) => {
  const { data, loading, refetch } = usePageConfigurationQuery();
  const pageConfigData: ContextData["data"] = !data?.cmsConfiguration?.page
    ? pageConfigInitialState
    : data.cmsConfiguration.page;

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      refetch();
    }

    return () => {
      mounted = false;
    };
  }, [refetch]);

  return (
    <PageConfigurationContext.Provider
      value={{
        data: pageConfigData,
        loading: loading,
      }}
    >
      {children}
    </PageConfigurationContext.Provider>
  );
};
